import { Injectable, inject } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { MarketHelpConfig } from '@frontend/sports/common/client-config-data-access';
import { ExpiringCache, ExpiringCacheFactory } from '@frontend/sports/common/core/utils/expiring-cache';
import { Observable } from 'rxjs';

import { IMarketHelpResponse } from './model';

@Injectable({ providedIn: 'root' })
export class MarketHelpService {
    private apiService = inject(ApiService);

    private cache: ExpiringCache;

    constructor() {
        const cacheFactory = inject(ExpiringCacheFactory);
        const config = inject(MarketHelpConfig);

        this.cache = cacheFactory.create(config.marketHelpCacheTimeout);
    }

    getHelp(key: string): Observable<IMarketHelpResponse> {
        const source = this.apiService.get<IMarketHelpResponse>('markethelp', {
            key,
        });

        return this.cache.getOrCreate(key, source);
    }
}
